import {
  useEffect,
  useMemo
} from 'react';
import Cookies from 'js-cookie';
import {
  useDispatch,
  useSelector
} from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import {
  CssBaseline,
  StyledEngineProvider
} from '@mui/material';
import Routes from './routes';
import themes from './themes';
import NavigationScroll from './layout/NavigationScroll';
import {
  logoutUser,
  checkUser
} from './store/actions/userActions';
import { THEME_STORAGE_KEY } from './store/customizationReducer';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/lt';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { initNotificationsSocket } from './lib/socket';

dayjs.locale('lt');

const App = () => {
  const customization = useSelector((state) => state.customization);
  const dispatch = useDispatch();

  const theme = useMemo(() => themes(customization), [customization]);

  useEffect(() => {
    const mode = customization.navType === 'dark' ? 'dark' : 'light';
    try {
      window.localStorage.setItem(THEME_STORAGE_KEY, mode);
    } catch (e) { }
    document.documentElement.setAttribute('data-theme', mode);
    document.documentElement.style.colorScheme = mode;
  }, [customization.navType]);

  useEffect(() => {
    initNotificationsSocket();
  }, []);

  useEffect(() => {
    window.scrollTo(200, 100);
    const cookieToken = Cookies.get('tkn');

    if (cookieToken) {
      dispatch(checkUser());
    } else {
      dispatch(logoutUser());
    }
  }, []);

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="lt"
    >
      <StyledEngineProvider
        injectFirst
      >
        <ThemeProvider
          theme={theme}
        >
          <CssBaseline />
          <NavigationScroll>
            <Routes />
          </NavigationScroll>
        </ThemeProvider>
      </StyledEngineProvider>
    </LocalizationProvider>
  );
};

export default App;